import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import ErrorBoundary from "./components/ErrorBoundary.js";
import "./styles/reset.css";
import "./styles/tokens.css";
import "./App.css";
import "./styles/chat.css";
import "./styles/sidebar.css";
import "./styles/portfolio.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
	throw new Error("Root element not found — check index.html has a #root div");
}

ReactDOM.createRoot(rootElement).render(
	<React.StrictMode>
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	</React.StrictMode>
);
